import { Button, Grid } from "designSystem/index";
import React from "react";

export default () => (
	<Grid
		container
		direction="column"
		spacing={4}
	>
		<Grid item>
			<Button design="primary" fullWidth>Primary</Button>
		</Grid>
		<Grid item>
			<Button design="secondary" fullWidth>Secondary</Button>
		</Grid>
		<Grid item>
			<Button design="outline" fullWidth>Outline</Button>
		</Grid>
		<Grid item>
			<Button design="link" fullWidth>Link</Button>
		</Grid>
		<Grid item>
			<Button design="linkSubtle" fullWidth>Link Subtle</Button>
		</Grid>
	</Grid>
);